export default __webpack_public_path__ + "static/media/widget-button.194e06f4.svg";